import { useEffect } from 'react'

import { getExpoPushToken, getIsMobileAppMode } from '@taxfix/scouts-helpers'

import config from '@/config'
import { getBaseUrl } from '@/helpers/url-domain'
import { useAppDispatch } from '@/store'
import { disablePushNotifications } from '@/store/profile'

import { useResetSessionAndLogout } from './hooks/use-reset-session-and-logout'

export const Logout = () => {
    const dispatch = useAppDispatch()
    const { resetSessionAndLogout, isSuccess } = useResetSessionAndLogout()

    const isMobileAppMode = getIsMobileAppMode()
    const expoPushToken = getExpoPushToken()

    const redirectUrl = isMobileAppMode ? getBaseUrl() : config.siteLogoutUrl

    useEffect(() => {
        if (expoPushToken) {
            dispatch(disablePushNotifications(expoPushToken)).finally(() => {
                resetSessionAndLogout()
            })
            return
        }

        resetSessionAndLogout()
    }, [dispatch, expoPushToken, resetSessionAndLogout])

    useEffect(() => {
        if (!isSuccess) return

        window.location.replace(redirectUrl)
    }, [isSuccess, redirectUrl])

    return null
}
